<template>
  <div class="faq-page">
    <article class="faq-card">
      <h1 class="faq-card__title">{{ $t('pages.faqTitle') }}</h1>

      <div class="faq-search">
        <i class="el-icon-search faq-search__icon" aria-hidden="true"></i>
        <input
          v-model.trim="keyword"
          type="search"
          class="faq-search__input"
          :placeholder="$t('faq.searchPh')"
        >
      </div>

      <div class="faq-list">
        <section
          v-for="item in filteredItems"
          :key="item.id"
          class="faq-item"
        >
          <h2 class="faq-item__q">{{ item.q }}</h2>
          <p class="faq-item__a">{{ item.a }}</p>
        </section>
        <p v-if="!filteredItems.length" class="faq-empty">{{ $t('faq.noResult') }}</p>
      </div>

      <footer class="faq-footer">
        <span class="faq-footer__text">{{ $t('faq.notFound') }}</span>
        <el-button type="primary" size="small" class="faq-footer__btn" @click="onContact">
          {{ $t('faq.contact') }}
        </el-button>
      </footer>
    </article>
  </div>
</template>

<script>
export default {
  name: 'FaqPage',
  data() {
    return {
      keyword: ''
    }
  },
  computed: {
    items() {
      return [
        { id: 'buy', q: this.$t('faq.q1'), a: this.$t('faq.a1') },
        { id: 'pay', q: this.$t('faq.q2'), a: this.$t('faq.a2') },
        { id: 'rebind', q: this.$t('faq.q3'), a: this.$t('faq.a3') },
        { id: 'password', q: this.$t('faq.q4'), a: this.$t('faq.a4') },
        { id: 'register', q: this.$t('faq.q5'), a: this.$t('faq.a5') },
        { id: 'effect', q: this.$t('faq.q6'), a: this.$t('faq.a6') },
        { id: 'refund', q: this.$t('faq.q7'), a: this.$t('faq.a7') }
      ]
    },
    filteredItems() {
      const kw = this.keyword.trim().toLowerCase()
      if (!kw) return this.items
      return this.items.filter((item) => {
        return item.q.toLowerCase().includes(kw) || item.a.toLowerCase().includes(kw)
      })
    }
  },
  methods: {
    onContact() {
      this.$message.info(this.$t('faq.contactHint'))
    }
  }
}
</script>

<style scoped>
.faq-page {
  width: 100%;
  padding-bottom: 24px;
}

.faq-card {
  padding: 32px 36px 0;
  border-radius: 16px;
  background: #fff;
  border: 1px solid rgba(148, 163, 184, 0.16);
  box-shadow: 0 4px 18px rgba(15, 23, 42, 0.06);
}

.faq-card__title {
  margin: 0;
  color: #1f2d3d;
  font-size: clamp(22px, 2.8vw, 28px);
  font-weight: 700;
  line-height: 1.3;
  letter-spacing: -0.02em;
}

.faq-search {
  position: relative;
  margin-top: 22px;
}

.faq-search__icon {
  position: absolute;
  left: 14px;
  top: 50%;
  color: #94a3b8;
  font-size: 16px;
  transform: translateY(-50%);
  pointer-events: none;
}

.faq-search__input {
  width: 100%;
  height: 42px;
  padding: 0 14px 0 40px;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  background: #fff;
  color: #1f2d3d;
  font-size: 14px;
  line-height: 1;
  box-sizing: border-box;
  outline: none;
  transition: border-color 180ms ease, box-shadow 180ms ease;
}

.faq-search__input::placeholder {
  color: #94a3b8;
}

.faq-search__input:focus {
  border-color: #2f6bff;
  box-shadow: 0 0 0 3px rgba(47, 107, 255, 0.1);
}

.faq-list {
  margin-top: 8px;
}

.faq-item {
  padding: 22px 0;
  border-bottom: 1px solid #eef2f6;
}

.faq-item__q {
  margin: 0;
  color: #1f2d3d;
  font-size: 15px;
  font-weight: 700;
  line-height: 1.5;
}

.faq-item__a {
  margin: 10px 0 0;
  color: #64748b;
  font-size: 14px;
  line-height: 1.85;
}

.faq-empty {
  margin: 28px 0;
  color: #94a3b8;
  font-size: 14px;
  text-align: center;
}

.faq-footer {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 14px;
  margin: 8px -36px 0;
  padding: 22px 36px;
  border-radius: 0 0 16px 16px;
  background: #f8fafc;
}

.faq-footer__text {
  color: #64748b;
  font-size: 14px;
}

.faq-footer__btn {
  min-width: 96px;
  border-radius: 8px;
}

@media (max-width: 640px) {
  .faq-card {
    padding: 22px 18px 0;
  }

  .faq-footer {
    flex-direction: column;
    gap: 12px;
    margin: 8px -18px 0;
    padding: 20px 18px;
  }
}
</style>
